import { playerUrl, options } from './podigee_podcast_player_config'

up.compiler('.js-init_podigee_podcast_player', function (element, data) {
  const config = { ...data.player_config, options }

  window[`playerConfiguration_${data.player_id}`] = config

  const script = document.createElement('script')
  script.classList.add('podigee-podcast-player')
  script.classList.add('test-podcast_player')
  script.dataset.configuration = `playerConfiguration_${data.player_id}`
  script.dataset.options = JSON.stringify({ iframeTitle: data.iframe_title })
  script.setAttribute('src', playerUrl)
  element.parentNode.appendChild(script)
})
